import {isUnitFaction} from "./isUnitFaction";

// Есть ли у игрока хотя бы один юнит указанной фракции — используется вместо
// isPlayerFaction(player, factionId) там, где способность привязана к юниту
// (например, неограниченное снабжение Великанов), а не к фракции игрока:
// после захвата суккубом чужой юнит сохраняет свою исходную фракцию (unit.factionId)
// независимо от фракции его нового владельца (см. design.md Decision 10)
export const checkIfPlayerHasUnitOfFaction = (player, factionId, units) => {
  if (!player) {
    return false;
  }

  return units.some(unit => unit.ownerId === player.id && isUnitFaction(unit, factionId));
}
